import { useEffect, useState } from "react";
import { ProductApp } from "./ProductApp";
import { CompanyLanding } from "./CompanyLanding";

export function isCompanyPublicLocation(host: string, path: string, hash: string): boolean {
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.fivecrownsystem\.com$/.test(host)
    && (path === "/" || path === "/play")
    && !hash.startsWith("#/company") && !hash.startsWith("#/owner");
}

export function EntryApp(): React.JSX.Element {
  const [hash, setHash] = useState(location.hash);
  useEffect(() => { const update = (): void => setHash(location.hash); window.addEventListener("hashchange", update); return () => window.removeEventListener("hashchange", update); }, []);
  return isCompanyPublicLocation(location.hostname, location.pathname, hash)
    ? <CompanyLanding /> : <ProductApp />;
}
